import request from "@/utils/request";

/* ----------------------------------- 城市表 - city - 相关API ----------------------------------- */

/**
 * 获取城市列表
 * @returns list (需要进一步处理)
 */
export function getCityCityList() {
  return request({
    url: "/api/analyse/air/city/city/list",
    method: "get"
  });
}

/**
 * 根据城市编号获取城市名称
 * @param {String} code
 * @returns
 */
export function getCityCityNameByCode(code) {
  return request({
    url: "/api/analyse/air/city/city/one/" + code,
    method: "get"
  });
}

/**
 * 单城市 某一年 的 年数据
 * @param { String } year 年份
 * @param { String } code 城市code
 * @returns list
 */
export function getCity365DayData(year, code) {
  return request({
    url: "/api/analyse/air/city/city/aqi/" + year + "/" + code,
    method: "get"
  });
}

// 根据年份、站点编号获取站点365天数据
export function getMp365AqiData(year, code) {
  return request({
    url: "/api/analyse/air/mp/city/aqi/" + year + "/" + code,
    method: "get"
  });
}

/**
 * 根据日期+日期类型获取全部数据 (不分页)
 * @param { String } date  日期
 * @param { String } type   hour 或者 day
 * @returns list
 */
export function aqiOfCity(date, type) {
  return request({
    url: "/api/analyse/air/city/aqi?date=" + date + "&type=" + type,
    method: "get"
  });
}

/**
 * 根据日期、城市名称获取该城市前一小时的数据和在所有城市中的排名
 * @param {String} date 日期
 * @param {String} city 城市名称
 * @returns JSON (map)
 */
export function getCityPrevHourRanking(date, city) {
  return request({
    url: "/api/analyse/air/city/aqi/ranking/" + date + "/" + city,
    method: "get"
  });
}

/**
 * 根据日期、城市编码获取该月度统计优良天数据
 * @param {String} date 日期
 * @param {String} cityCode 城市编码
 * @returns JSON
 */
export function getCityQualityStatistics(date, cityCode) {
  return request({
    url:
      "/api/analyse/air/city/statistics/month/quality?date=" +
      date +
      "&cityCode=" +
      cityCode,
    method: "get"
  });
}

/**
 * 根据日期、城市编码获取月度统计污染物数据
 * @param {String} date 日期
 * @param {String} cityCode 城市编码
 * @returns JSON
 */
export function getCityPollutionsStatistics(date, cityCode) {
  return request({
    url:
      "/api/analyse/air/city/statistics/month/pollutions?date=" +
      date +
      "&cityCode=" +
      cityCode,
    method: "get"
  });
}

/**
 * 根据日期、城市编码获取月统计综合指数数据
 * @param {String} date 日期
 * @param {String} cityCode 城市编码
 * @returns JSON
 */
export function getCityCompositeIndexStatistics(date, cityCode) {
  return request({
    url:
      "/api/analyse/air/city/statistics/month/compositeIndex?date=" +
      date +
      "&cityCode=" +
      cityCode,
    method: "get"
  });
}

/**
 * 区间日期、多城市获取aqi日数据
 * @param { Stirng[] codes, Stirng[] dates} data
 * @returns JSON
 */
export function getCityAqiBewteen(data) {
  return request({
    url: "/api/analyse/air/city/aqi/between/map",
    method: "post",
    data: data
  });
}

/**
 * 区间日期、多城市、数据类型 获取aqi日数据
 * @param { Stirng[] codes, Stirng[] dates,String type} data
 * @returns List
 */
export function getCityAqiBewteenList(data) {
  return request({
    url: "/api/analyse/air/city/aqi/between/list",
    method: "post",
    data: data
  });
}
/**
 * 区间日期、省份、数据类型 获取aqi日数据
 * @param { Stirng province, Stirng[] dates,String type} data
 * @returns List
 */
export function getCityAqiBewteenListOfProvince(data) {
  return request({
    url: "/api/analyse/air/city/aqi/between/list/province",
    method: "post",
    data: data
  });
}

/**
 * 导出数据 下载excel 区间日期、多城市、数据类型 获取aqi日数据
 * @param { Stirng[] codes, Stirng[] dates,String type} data
 * @returns List
 */
export function exportCityData(data) {
  // let url = "http://127.0.0.1:8088" +"/api/analyse/air/city/export";
  // console.log(url)
  // openPostWindow(url,params);
  return request({
    url: "/api/analyse/air/city/export",
    method: "post",
    data: data,
    responseType: "blob"
  });
}

/**
 * 导出数据 下载excel 区间日期、多城市、数据类型 获取aqi日数据
 * @param { Stirng[] codes, Stirng[] dates,String type} data
 * @returns List
 */
export function exportMeCityData(data) {
  // let url = "http://127.0.0.1:8088" +"/api/analyse/air/city/export";
  // console.log(url)
  // openPostWindow(url,params);
  return request({
    url: "/api/analyse/air/city/exportMe",
    method: "post",
    data: data,
    responseType: "blob"
  });
}

/* ----------------------------------- 国控点表 - Mp - 相关API ----------------------------------- */

/**
 * 获取城市列表
 * @returns list (需要进一步处理)
 */
export function getMpCityList() {
  return request({
    url: "/api/analyse/air/mp/city/list",
    method: "get"
  });
}

/**
 * 根据站点编号获取城市名称
 * @param {String} code  站点编号
 * @returns String
 */
export function getMpMpNameByCode(code) {
  return request({
    url: "/api/analyse/air/mp/city/one/" + code,
    method: "get"
  });
}

/**
 * 获取单城市 所有站点
 * @param {String} cityCode
 * @returns list
 */
export function getMpPointList(cityCode) {
  return request({
    url: "/api/analyse/air/mp/point/list/" + cityCode,
    method: "get"
  });
}

/**
 * 根据日期+日期类型获取全部数据 (不分页)
 * @param {String} city 城市编码
 * @param {String} date 日期
 * @param {String} type  hour 或者 day
 * @returns list
 */
export function aqiOfMp(city, date, type) {
  return request({
    url:
      "/api/analyse/air/mp/aqi?city=" +
      city +
      "&date=" +
      date +
      "&type=" +
      type,
    method: "get"
  });
}

/**
 * 根据日期+日期类型获取全部数据 (不分页)
 * @param {String} date 日期
 * @param {String} type  hour 或者 day
 * @returns list
 */
export function aqiOfMpAll(date, type) {
  return request({
    url: "/api/analyse/air/mp/aqi/all?date=" + date + "&type=" + type,
    method: "get"
  });
}

/**
 * 根据日期、城市编码获取该月度统计优良天数据
 * @param {String} date 日期
 * @param {String} cityCode 城市编码
 * @returns JSON
 */
export function getMpQualityStatistics(date, cityCode, mpCode) {
  return request({
    url:
      "/api/analyse/air/mp/statistics/month/quality?date=" +
      date +
      "&cityCode=" +
      cityCode +
      "&mpCode=" +
      mpCode,
    method: "get"
  });
}

/**
 * 根据日期、城市编码获取-月统计污染物数据
 * @param {String} date 日期
 * @param {String} cityCode 城市编码
 * @returns JSON
 */
export function getMpPollutionsStatistics(date, cityCode, mpCode) {
  return request({
    url:
      "/api/analyse/air/mp/statistics/month/pollutions?date=" +
      date +
      "&cityCode=" +
      cityCode +
      "&mpCode=" +
      mpCode,
    method: "get"
  });
}

/**
 * 根据日期、城市编码获取月统计综合指数数据
 * @param {String} date 日期
 * @param {String} cityCode 城市编码
 * @returns JSON
 */
export function getMpCompositeIndexStatistics(date, cityCode, mpCode) {
  return request({
    url:
      "/api/analyse/air/mp/statistics/month/compositeIndex?date=" +
      date +
      "&cityCode=" +
      cityCode +
      "&mpCode=" +
      mpCode,
    method: "get"
  });
}

/**
 * 区间日期、多城市获取aqi日数据
 * @param { Stirng[] codes, Stirng[] dates} data
 * @returns JSON
 */
export function getMpAqiBewteen(data) {
  return request({
    url: "/api/analyse/air/mp/aqi/between/map",
    method: "post",
    data: data
  });
}

/**
 * 区间日期、单城市、多站带你获取aqi日或小时数据
 * @param {object} data
 * @returns
 */
export function getMpAqiBewteenList(data) {
  return request({
    url: "/api/analyse/air/mp/aqi/between/list",
    method: "post",
    data: data
  });
}

/**
 * 导出数据 下载excel 区间日期、单城市、多站带你获取aqi日或小时数据
 * @param { Stirng[] codes, Stirng[] dates,String type} data
 * @returns Excel file Blob
 */
export function exportMpData(data) {
  return request({
    url: "/api/analyse/air/mp/export",
    method: "post",
    data: data,
    responseType: "blob"
  });
}

/* ----------------------------------- 省控点表 - Mppro - 相关API ----------------------------------- */

/**
 * 获取城市列表
 * @returns list (需要进一步处理)
 */
export function getMpProCityList() {
  return request({
    url: "/api/analyse/air/mp/pro/city/list",
    method: "get"
  });
}

/**
 * 根据日期+日期类型获取全部数据 (不分页)
 * @param {String} city 城市编码
 * @param {String} date 日期
 * @param {String} type hour 或者 day
 * @returns list
 */
export function aqiOfMpPro(city, date, type) {
  return request({
    url:
      "/api/analyse/air/mp/pro/aqi?city=" +
      city +
      "&date=" +
      date +
      "&type=" +
      type,
    method: "get"
  });
}

/**
 * 根据日期、城市编码获取该月度统计优良天数据
 * @param {String} date 日期
 * @param {String} cityCode 城市编码
 * @returns JSON
 */
export function getMpproQualityStatistics(date, cityCode, mpCode) {
  return request({
    url:
      "/api/analyse/air/mp/pro/statistics/month/quality?date=" +
      date +
      "&cityCode=" +
      cityCode +
      "&mpCode=" +
      mpCode,
    method: "get"
  });
}

/**
 * 根据日期、城市编码获取-月统计污染物数据
 * @param {String} date 日期
 * @param {String} cityCode 城市编码
 * @returns JSON
 */
export function getMpproPollutionsStatistics(date, cityCode, mpCode) {
  return request({
    url:
      "/api/analyse/air/mp/pro/statistics/month/pollutions?date=" +
      date +
      "&cityCode=" +
      cityCode +
      "&mpCode=" +
      mpCode,
    method: "get"
  });
}

/**
 * 根据日期、城市编码获取月统计综合指数数据
 * @param {String} date 日期
 * @param {String} cityCode 城市编码
 * @returns JSON
 */
export function getMpproCompositeIndexStatistics(date, cityCode, mpCode) {
  return request({
    url:
      "/api/analyse/air/mp/pro/statistics/month/compositeIndex?date=" +
      date +
      "&cityCode=" +
      cityCode +
      "&mpCode=" +
      mpCode,
    method: "get"
  });
}



// WEBPACK FOOTER //
// ./src/api/ruleAnalyse.js